import React, { Component } from 'react';
import Profile from './Profile'
import ChangePassword from './ChangePassword'

class ProfileDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            renderState: 'info'
        }
    }

    getMainContent() {
        if (this.state.renderState === 'info') {
            return (<Profile history={this.props.history} user={this.props.user} updateUserProfile={this.props.updateUserProfile}/>);
        } else {
            return (<ChangePassword history={this.props.history} user={this.props.user}/>)
        }
    }

    changeRenderState(renderState) {
        this.setState({
            renderState: renderState
        });
    }

    render() {
        return (
            <section className="content-wrapper">
                <div className="main-content d-flex flex-container">
                    <div style={{'width' : '200px'}}>
                        <div className="nav flex-column nav-tabs h-100" role="tablist" aria-orientation="vertical">
                            <a className="nav-link active" data-toggle="pill" href="#vert-tabs-home" role="tab" aria-controls="vert-tabs-home" aria-selected="true" onClick={() => this.changeRenderState('info')}>Account info</a>
                            <a className="nav-link" data-toggle="pill" href="#vert-tabs-profile" role="tab" aria-controls="vert-tabs-profile" aria-selected="false" onClick={() => this.changeRenderState('password')}>Change password</a>
                        </div>
                    </div>
                    <div style={{'flex-grow' : '12'}}>
                        {this.getMainContent()}
                    </div>
                </div>
            </section>
        )
    }

}

export default ProfileDetails;